import { Link } from "react-router-dom";
import { openCookieBanner } from "@/lib/consent";
import { MapPin, Phone, Mail, Clock } from "lucide-react";
import { COMPANY, NAV_LINKS } from "@/data/site";

const Footer = () => (
  <footer data-testid="site-footer" className="border-t border-white/10 bg-ink">
    <div className="mx-auto max-w-[1600px] px-6 py-16 md:px-12 md:py-20">
      <div className="grid grid-cols-1 gap-12 lg:grid-cols-12">
        <div className="lg:col-span-5">
          <div className="mb-5 flex items-center gap-2.5">
            <div className="flex h-9 w-9 items-center justify-center rounded-md bg-brand">
              <span className="font-display text-lg font-extrabold text-white">M</span>
            </div>
            <div className="leading-none">
              <div className="font-display text-lg font-extrabold uppercase tracking-tight text-white">
                MAGIT
              </div>
              <div className="text-[8px] font-semibold uppercase tracking-[0.3em] text-white/40">
                Impianti & Tecnologie
              </div>
            </div>
          </div>
          <p className="max-w-sm text-sm leading-relaxed text-white/50">
            {COMPANY.legal} — dal 2009 impianti elettrici, climatizzazione e manutenzione
            specialistica di poligoni di tiro a Napoli. Ingegneria a regola d'arte.
          </p>
        </div>

        <div className="lg:col-span-3">
          <h4 className="mb-5 text-[11px] font-semibold uppercase tracking-[0.2em] text-white/40">
            Navigazione
          </h4>
          <ul className="space-y-3 text-sm">
            {NAV_LINKS.map((link) => (
              <li key={link.label}>
                <Link
                  to={link.to}
                  data-testid={`footer-link-${link.label.toLowerCase().replace(/\s/g, "-")}`}
                  className={`transition-colors hover:text-brand ${
                    link.highlight ? "text-brand" : "text-white/70"
                  }`}
                >
                  {link.label}
                </Link>
              </li>
            ))}
            <li>
              <Link to="/manutenzione-poligoni-di-tiro" data-testid="footer-link-poligoni" className="text-white/70 transition-colors hover:text-brand">
                Manutenzione poligoni di tiro
              </Link>
            </li>
          </ul>
        </div>

        <div className="lg:col-span-4">
          <h4 className="mb-5 text-[11px] font-semibold uppercase tracking-[0.2em] text-white/40">
            Contatti
          </h4>
          <ul className="space-y-4 text-sm">
            <li className="flex items-start gap-3 text-white/70">
              <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-brand" />
              <span>{COMPANY.address}</span>
            </li>
            <li className="flex items-start gap-3 text-white/70">
              <Phone className="mt-0.5 h-4 w-4 shrink-0 text-brand" />
              <a href={`tel:${COMPANY.phoneRaw}`} className="hover:text-brand">
                {COMPANY.phoneDisplay}
              </a>
            </li>
            <li className="flex items-start gap-3 text-white/70">
              <Mail className="mt-0.5 h-4 w-4 shrink-0 text-brand" />
              <a href={`mailto:${COMPANY.email}`} className="hover:text-brand">
                {COMPANY.email}
              </a>
            </li>
            <li className="flex items-start gap-3 text-white/70">
              <Mail className="mt-0.5 h-4 w-4 shrink-0 text-brand" />
              <a href={`mailto:${COMPANY.pec}`} data-testid="footer-pec" className="hover:text-brand">
                PEC: {COMPANY.pec}
              </a>
            </li>
            <li className="flex items-start gap-3 text-white/70">
              <Clock className="mt-0.5 h-4 w-4 shrink-0 text-brand" />
              <span>{COMPANY.hours}</span>
            </li>
          </ul>
        </div>
      </div>

      <div className="mt-14 flex flex-col gap-2 border-t border-white/10 pt-6 text-xs text-white/40 sm:flex-row sm:items-center sm:justify-between">
        <span>
          © {new Date().getFullYear()} {COMPANY.legal} — P.IVA {COMPANY.piva}
        </span>
        <span className="flex flex-wrap gap-x-4 gap-y-1">
          <Link to="/privacy-policy" data-testid="footer-link-privacy" className="hover:text-white">Privacy Policy</Link>
          <Link to="/cookie-policy" data-testid="footer-link-cookie" className="hover:text-white">Cookie Policy</Link>
          <button type="button" onClick={openCookieBanner} data-testid="footer-cookie-preferences" className="hover:text-white">
            Preferenze cookie
          </button>
        </span>
      </div>
    </div>
  </footer>
);

export default Footer;
